import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        tasklist: '=',
        tasklistTemplates: '=',
        classifiers: '='
    },
    template: `
        <user-tasklist-form
            tasklist="vm.tasklist"
            tasklist-templates="vm.tasklistTemplates"
            classifiers="vm.classifiers"
            is-add="vm.isAdd"
        />`
})
export default class {
    $onInit () {
        this.isAdd = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/tasklist/add/index.js